import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/laredo")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Laredo, TX | Texas Made Shade",
      description: "Custom welded awnings, commercial canopies, patio & pergola covers and sail shades for Laredo & Webb County. Free quotes — +1 (830) 390-9588.",
      keywords: "pergola covers Laredo, pergola covers Texas, custom pergola covers Laredo, aluminum pergola covers Laredo",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Laredo, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Laredo and Webb County.",
    }),
    scripts: cityHeadScripts("Laredo", "Webb County"),
  }),
  component: () => <CityHomePage city="Laredo" region="Webb County" />,
});
